import { isValidElement } from 'react';

function checkForElementChildType(child) {
  return /*#__PURE__*/isValidElement(child) && typeof (child === null || child === void 0 ? void 0 : child.type) !== "string" && typeof (child === null || child === void 0 ? void 0 : child.type) !== "number" && typeof (child === null || child === void 0 ? void 0 : child.type) !== "boolean";
}
var OVERLAYS_REGEX = /Modal|Tooltip|Drawer|Popover/;
var STICKER_REGEX = /Sticker/;
var TARGET_REGEX = /\.Target/;

// @TODO: consider making this function recursive
// https://immutable.atlassian.net/browse/DS-938
function isChildSubcomponent(child,
// biome-ignore lint/suspicious/noExplicitAny: <explanation>
subcomponent) {
  if (checkForElementChildType(child)) {
    var _child$type, _child$type2, _child$type3;
    if (child.type === subcomponent) {
      return true;
    }

    // @NOTE: allow for when the child is a SmartClone component,
    // and the desired subcomponent as its child
    if (
    // @TODO: not sure why the below crashes webpack:
    // child.type === SmartClone - need to investigate
    ((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === "SmartClone" && child.props.children.type === subcomponent) {
      return true;
    }

    // @NOTE: allow for when the child is an overlay component,
    // and the desired subcomponent is its Target child
    if (OVERLAYS_REGEX.test((_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName)) {
      var _child$props$children, _potentialTargetEleme;
      var potentialTargetElement = (_child$props$children = child.props.children) === null || _child$props$children === void 0 ? void 0 : _child$props$children[0];
      if (TARGET_REGEX.test(potentialTargetElement === null || potentialTargetElement === void 0 || (_potentialTargetEleme = potentialTargetElement.type) === null || _potentialTargetEleme === void 0 ? void 0 : _potentialTargetEleme.displayName)) {
        var _potentialTargetEleme2, _targetChild$type;
        var targetChild = potentialTargetElement === null || potentialTargetElement === void 0 || (_potentialTargetEleme2 = potentialTargetElement.props) === null || _potentialTargetEleme2 === void 0 ? void 0 : _potentialTargetEleme2.children;
        if ((targetChild === null || targetChild === void 0 ? void 0 : targetChild.type) === subcomponent) {
          return true;
        }

        // check for when an Sticker component is used nested within an Overlay:
        if (STICKER_REGEX.test((_targetChild$type = targetChild.type) === null || _targetChild$type === void 0 ? void 0 : _targetChild$type.displayName)) {
          var stickerChildren = targetChild.props.children;
          var containsSubcomponent = Array.isArray(stickerChildren) ?
          // biome-ignore lint/suspicious/noExplicitAny: <explanation>
          stickerChildren.some(function (c) {
            return (c === null || c === void 0 ? void 0 : c.type) === subcomponent;
          }) : (stickerChildren === null || stickerChildren === void 0 ? void 0 : stickerChildren.type) === subcomponent;
          return containsSubcomponent;
        }
      }
    }

    // @NOTE: allow for when the child is a Sticker component,
    // and the desired subcomponent is its first child
    if (STICKER_REGEX.test((_child$type3 = child.type) === null || _child$type3 === void 0 ? void 0 : _child$type3.displayName)) {
      var _child$props, _rootChildren$type;
      var rootChildren = child === null || child === void 0 || (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.children;
      var _containsSubcomponent = Array.isArray(rootChildren) ?
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      rootChildren.some(function (c) {
        return (c === null || c === void 0 ? void 0 : c.type) === subcomponent;
      }) : (rootChildren === null || rootChildren === void 0 ? void 0 : rootChildren.type) === subcomponent;
      if (_containsSubcomponent) {
        return true;
      }

      // check for when an overlay component is used nested within Sticker:
      var nestedOverlay = Array.isArray(rootChildren) ?
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      rootChildren.find(function (c) {
        var _c$type;
        return OVERLAYS_REGEX.test(c === null || c === void 0 || (_c$type = c.type) === null || _c$type === void 0 ? void 0 : _c$type.displayName);
      }) : OVERLAYS_REGEX.test(rootChildren === null || rootChildren === void 0 || (_rootChildren$type = rootChildren.type) === null || _rootChildren$type === void 0 ? void 0 : _rootChildren$type.displayName) ? rootChildren : null;
      if (nestedOverlay) {
        var _nestedOverlay$props;
        var _potentialTargetElement = nestedOverlay === null || nestedOverlay === void 0 || (_nestedOverlay$props = nestedOverlay.props) === null || _nestedOverlay$props === void 0 || (_nestedOverlay$props = _nestedOverlay$props.children) === null || _nestedOverlay$props === void 0 ? void 0 : _nestedOverlay$props.find(
        // biome-ignore lint/suspicious/noExplicitAny: <explanation>
        function (c) {
          var _c$type2;
          return TARGET_REGEX.test(c === null || c === void 0 || (_c$type2 = c.type) === null || _c$type2 === void 0 ? void 0 : _c$type2.displayName);
        });
        if (_potentialTargetElement) {
          var _potentialTargetEleme3;
          var _targetChild = _potentialTargetElement === null || _potentialTargetElement === void 0 || (_potentialTargetEleme3 = _potentialTargetElement.props) === null || _potentialTargetEleme3 === void 0 ? void 0 : _potentialTargetEleme3.children;
          return (_targetChild === null || _targetChild === void 0 ? void 0 : _targetChild.type) === subcomponent;
        }
      }
    }
  }
  return false;
}
function getSubcomponentChild(children,
// biome-ignore lint/suspicious/noExplicitAny: <explanation>
subcomponent) {
  if (Array.isArray(children)) {
    return children.find(function (child) {
      return isChildSubcomponent(child, subcomponent);
    });
  }
  return isChildSubcomponent(children, subcomponent) ? children : null;
}
function childIsStringOrNumber(child) {
  return typeof child === "string" || typeof child === "number";
}

export { checkForElementChildType, childIsStringOrNumber, getSubcomponentChild, isChildSubcomponent };
//# sourceMappingURL=subcomponentHelpers.js.map
